.fieldFullWidth {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.tagField {
  flex: 1;
  min-width: 0;
}

.addTagButton {
  white-space: nowrap;
}

.tagInputContainer {
  display: flex;
  align-items: flex-end;
  gap: 0.5rem;
}

.tagsList {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.75rem;
}

.getPromptsButton {
  --kui-btn-padding: 0.75rem 1.5rem;
  --kui-btn-bg: var(--accent);
  --kui-btn-border-color: var(--accent-dark);
  --kui-btn-radius: 8px;
  --kui-btn-font-size: 1rem;
  --kui-btn-bg-hover: var(--accent-light);
  --kui-btn-transform-hover: translateY(-1px);
  --kui-btn-transition: all 0.2s;
  --kui-btn-disabled-opacity: 0.6;
}

.promptsContainer {
  margin-top: 1rem;
  padding: 1rem;
  background: var(--bg);
  border: 1px solid var(--accent-dark);
  border-radius: 8px;
}

.promptsTitle {
  font-size: 1rem;
  font-weight: 600;
  color: var(--text);
  margin-bottom: 0.75rem;
}

.promptItem {
  padding: 0.75rem;
  margin-bottom: 0.5rem;
  background: var(--surface);
  border: 1px solid var(--accent-dark);
  border-radius: 6px;
  color: var(--text);
  line-height: 1.5;
}

.promptItem:last-child {
  margin-bottom: 0;
}

.imagesList {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 0.75rem;
}

.imageItem {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem;
  background: var(--surface);
  border: 1px solid var(--accent-dark);
  border-radius: 6px;
}

.imageName {
  color: var(--text);
  font-size: 0.95rem;
}

.removeImageButton {
  --kui-btn-padding-sm: 0.4rem 0.75rem;
  --kui-btn-font-size-sm: 0.9rem;
  --kui-btn-border-width: 0;
  --kui-btn-bg: var(--danger);
  --kui-btn-color: var(--on-danger);
  --kui-btn-radius: 4px;
  --kui-btn-bg-hover: var(--danger-hover);
  --kui-btn-transition: all 0.2s;
}

@media (max-width: 768px) {
  .tagInputContainer {
    flex-direction: column;
    align-items: stretch;
  }
}
